import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ApiModule, BASE_PATH } from 'coadapi';
import { AppComponent } from './app.component';
import { RoutingModule } from './app-routing.module';
import { LoginComponent } from './login/login.component';
import { WelcomeComponent } from './welcome/welcome.component';

import { MainComponent } from './main/main.component';
import { ServerModule } from 'app/server/server.module';
import { SharedModule } from 'app/shared/shared.module';
import { EppUsersModule } from 'app/epp-users/epp-users.module';
import { CrawlerStatusModule } from 'app/crawler-status/crawler-status.module';
import { ADMIN_API_SERVER_URL } from 'app/server/server.module';
import { EMS_API_SERVER_URL } from 'app/server/server.module';
import { PurchaseInvoiceModule } from 'app/purchase-invoice/purchase-invoice.module';
import { ExportToQuickbooksModule } from 'app/export-to-quickbooks/export-to-quickbooks.module';
import { DataAccessModule } from 'app/data-access/data-access.module';

import { environment } from 'environments/environment';
import { MaterialModule } from 'app/material.module';
import { EmailActionComponent } from 'app/email-action/email-action.component';
import { ProformaToDispatchComponent  } from './coad-web/proforma-to-dispatch/proforma-to-dispatch.component';
import { ProformaValueComponent } from './coad-web/proforma-value/proforma-value.component';
import { PfiDropdownComponent } from './coad-web/proforma-value/components/pfi-dropdown/pfi-dropdown.component';
import { InlandChargesDialogComponent } from './coad-web/proforma-value/components/inland-charges-dialog/inland-charges-dialog.component';
import { DispatchDetailsComponent } from './coad-web/dispatch-details/dispatch-details.component'
import { ChasingBoardComponent } from './coad-web/chasing-board/chasing-board.component'
import { ChaseNotesComponent } from './coad-web/chasing-board/pages/dialogs/chase-notes/chase-notes.component'
import { StaffListComponent } from './coad-web/chasing-board/pages/dialogs/staff-list/staff-list.component'
import { StaffFilterPipe } from './coad-web/chasing-board/abstracts/_staff-filter.pipe'
import { AssignmentsWarehouseFilterPipe, SuppliersWarehouseFilterPipe, DispatchesWarehouseFilterPipe } from './coad-web/chasing-board/abstracts/_snapshot-warehouse-filters'
import { CommentActionService } from './coad-web/chasing-board/abstracts/_data-sharing'
import { NotesDialogComponent } from './coad-web/dispatch-details/pages/dialogs/notes-dialog/notes-dialog.component'
import { ConfirmationComponent } from './coad-web/dialogs/confirmation/confirmation.component'
import { OkayComponent } from './coad-web/dialogs/okay/okay.component'
import { ClientComponent,  } from './coad-web/proforma-to-dispatch/pages/client/client.component';
import { IwdDeadlineComponent} from './coad-web/dialogs/iwd-deadline/iwd-deadline.component';
import { DatepickerInlineCalendarComponent } from './coad-web/proforma-to-dispatch/abstracts/_inline-calender';
import { RouterModule } from '@angular/router';
import { PipeModule } from './coad-web/proforma-to-dispatch/abstracts/_pipes'
import { ClientCountriesComponent } from './client-countries/client-countries.component';
import { ProductImagesComponent } from './product-images/product-images.component';
import { ProjectClosureComponent } from './project-closure/project-closure.component';
import { CheckPurchaseInvoicesComponent } from './check-purchase-invoices/check-purchase-invoices.component';
import { OrderProcessingComponent } from './order-processing/order-processing.component';
import { DuplicationDialogComponent } from './order-processing/duplication-dialog/duplication-dialog.component';
import { UnpricedWebOrdersComponent } from './order-processing/tabs/unpriced-web-orders.component';
import { WebOrdersComponent } from './order-processing/tabs/web-orders.component';
import { OrdersForReviewComponent } from './order-processing/tabs/orders-for-review.component';
import { ReviewWithClientComponent } from './order-processing/tabs/review-with-client.component';
import { ReviewWithSupplierComponent } from './order-processing/tabs/review-with-supplier.component';
import { ProformasAndQuotesComponent } from './order-processing/tabs/proformas-and-quotes.component';
import { ClientQueriesComponent } from './order-processing/tabs/client-queries.component';

export const EMS_DATE_FORMATS: MatDateFormats = {
  display: {
    dateInput: 'DD MMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD MMMM YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
  parse: {
    dateInput: 'DD MMM YYYY'
  }
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    WelcomeComponent,
    MainComponent,
    EmailActionComponent,
    ClientCountriesComponent,
    ProductImagesComponent,
    ClientComponent,
    ProformaToDispatchComponent,
    ProformaValueComponent,
    PfiDropdownComponent,
    InlandChargesDialogComponent,
    DispatchDetailsComponent,
    ChasingBoardComponent,
    ChaseNotesComponent,
    StaffListComponent,
    StaffFilterPipe,
    AssignmentsWarehouseFilterPipe,
    SuppliersWarehouseFilterPipe,
    DispatchesWarehouseFilterPipe,
    NotesDialogComponent,
    ConfirmationComponent,
    OkayComponent,
    IwdDeadlineComponent,
    ProjectClosureComponent,
    DatepickerInlineCalendarComponent,
    CheckPurchaseInvoicesComponent,
    OrderProcessingComponent,
    DuplicationDialogComponent,
    UnpricedWebOrdersComponent,
    WebOrdersComponent,
    OrdersForReviewComponent,
    ReviewWithClientComponent,
    ReviewWithSupplierComponent,
    ProformasAndQuotesComponent,
    ClientQueriesComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    RoutingModule,
    PipeModule,
    SharedModule,
    ApiModule,
    HttpClientModule,
    FlexLayoutModule,
    NgScrollbarModule,
    ServerModule,
    EppUsersModule,
    CrawlerStatusModule,
    PurchaseInvoiceModule,
    RouterModule,
    ExportToQuickbooksModule,
    DataAccessModule
  ],
  providers: [
    { provide: EMS_API_SERVER_URL, useValue: environment.emsServerUrl },
    { provide: ADMIN_API_SERVER_URL, useValue: environment.serverUrl },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: MAT_DATE_FORMATS, useValue: EMS_DATE_FORMATS },
    { provide: BASE_PATH, useValue: environment.basePath },
    StaffFilterPipe, ChaseNotesComponent, CommentActionService,
    // SharedDispatchData,
    // DispatchDetailsTranslations
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AppModule { }


